export default __webpack_public_path__ + "media/color/emc-3e95e60c.svg";